/** @sfdc-extension-file SNK */

import type { ComponentPropsWithRef, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@/components/link';
import { cn } from '@/lib/utils';
import logo from '/images/spacenk-logo.svg';

type HeaderLogoProps = Omit<ComponentPropsWithRef<typeof Link>, 'to' | 'children'> & {
    imageClassName?: string;
};

/** Alignment is owned by the parent row, so this serves both header layouts. */
export const HeaderLogo = ({ className, imageClassName, ...props }: HeaderLogoProps): ReactElement => {
    const { t } = useTranslation('header');

    return (
        <Link to="/" className={cn('inline-flex items-center', className)} data-testid="header-logo" {...props}>
            <img
                src={logo}
                alt={t('logoAlt')}
                width={204}
                height={38}
                className={cn('h-6 w-auto lg:h-[38px] [filter:var(--header-logo-filter)]', imageClassName)}
            />
        </Link>
    );
};
